import React from 'react';
import {
  Menu,
  MenuItem,
} from '@mui/material';
import {
  IState,
  IProps,
} from './interfaces';
import VaultButton from '../../VaultButton';

export default class ThumbnailSelectionFromPlayer extends React.Component<IProps, IState> {
  state: IState = {
    anchorEl: null,
  };

  handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    this.setState({
      anchorEl: e.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleAssign = () => {
    const { onAssign } = this.props;

    onAssign();
    this.handleClose();
  };

  handleCheck = () => {
    const { onCheck } = this.props;

    onCheck();
    this.handleClose();
  };

  render() {
    const { thumbnailFrame } = this.props;
    const { anchorEl } = this.state;

    return (
      <>
        <VaultButton
          id="PublishPreviewPlayerThumbnail"
          variant="plainOnPaper"
          onClick={this.handleClick}
        >
          Thumbnail
        </VaultButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem
            onClick={() => this.handleAssign()}
          >
            Assign
          </MenuItem>
          <MenuItem
            onClick={() => this.handleCheck()}
            disabled={thumbnailFrame === null}
          >
            Check
          </MenuItem>
        </Menu>
      </>
    );
  }
}
